import { useMemo } from 'react'
import classnames from 'classnames'
import { SelectDropdown, CustomDropdownItemOption, type DropDownItemOptionComponentProps } from '../SelectDropdown/SelectDropdown'
import { IntegrationIcon } from '../IntegrationIcon'
import { type IntegrationServiceId } from '../../common/integrations'
import { type WorkspaceNode } from '../../store/documentConnectors/documentConnectors'
import { findWorkspacePathLabel, workspaceNodesToOptions } from './utils'
import styles from './WorkspaceSelector.module.scss'

const WorkspaceOption = ({ displayLabel, optionLabel, onClick, disabled, selected }: DropDownItemOptionComponentProps) =>
  disabled ? (
    <div className={styles.groupHeader}>{optionLabel}</div>
  ) : (
    <CustomDropdownItemOption role='button' onClick={onClick} className={classnames({ 'fw-semibold': selected })}>
      {displayLabel ?? optionLabel}
    </CustomDropdownItemOption>
  )

interface WorkspaceSelectorProps {
  serviceId: IntegrationServiceId
  workspaces: WorkspaceNode[]
  value: string | null
  onChange: (nodeId: string) => void
}

export const WorkspaceSelector = ({ serviceId, workspaces, value, onChange }: WorkspaceSelectorProps) => {
  const options = useMemo(() => workspaceNodesToOptions(workspaces), [workspaces])

  const selectedLabel = value ? findWorkspacePathLabel(workspaces, value) : null
  const initialSelectedOption = value && selectedLabel ? { id: value, label: selectedLabel } : null

  const WorkspaceIcon = useMemo(() => () => <IntegrationIcon serviceId={serviceId} width={16} height={16} />, [serviceId])

  return (
    <div className={styles.workspaceSelector}>
      <SelectDropdown
        options={options}
        initialSelectedOption={initialSelectedOption}
        placeholder='Select a location'
        searchable
        className={styles.selectButton}
        IconComponent={WorkspaceIcon}
        DropDownItemOptionComponent={WorkspaceOption}
        onOptionSelected={(option) => onChange(option.id)}
      />
    </div>
  )
}
